module.exports = __webpack_public_path__ + "static/media/ACOMPANANTE.870f9c2b.jpg";